import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import Store from "./redux/Store";
import { BrowserRouter as Router } from "react-router-dom";
import { pwa_modal } from "./redux/Login/LoginActionCreators";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

if (localStorage.pwa === undefined) {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    Store.dispatch(pwa_modal({ mode: true, event: e }));
  });
  window.addEventListener("appinstalled", (e) => {
    e.preventDefault();
    Store.dispatch(pwa_modal({ mode: false, event: {} }));
  });
}

ReactDOM.render(
  <Router>
    <Provider store={Store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById("root")
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          registration.update();
          // window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
